import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IAuctionState } from '../types';

export const UPDATE_AUCTION = 'AUCTION :: UPDATE_AUCTION';

export type TUpdateAuctionActionPayload = Pick<IAuctionState, 'nextBets' | 'previousBets' | 'currentBet'>;

export type TUpdateAuctionAction = IReduxAction<typeof UPDATE_AUCTION, TUpdateAuctionActionPayload>;

export const updateAuction = actionGenerator<typeof UPDATE_AUCTION, TUpdateAuctionActionPayload>(UPDATE_AUCTION);
